// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e4e0de6e","513":"f8272a98","703":"b205fee3","787":"d266b29c"}[chunkId] + ".chunk.js";
};